import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Inline } from '@zendeskgarden/react-loaders'
import { NavBar } from '../NavBar'
import { LayoutWrapper, PageContent } from './style'
import { useOrder } from '@/context'
import { SELECTED_ORDER_ID_KEY } from '@/context'

export function Layout() {
  const { isLoading, order, fetchOrder, fetchDocuments, documents } = useOrder()
  const { pathname } = useLocation()
  const hideNavBar = pathname === '/modal/formulario' || pathname === '/modal/sucesso';

  useEffect(() => {
    const orderId = localStorage.getItem(SELECTED_ORDER_ID_KEY)
    if (orderId && !order) {
      fetchOrder(orderId)
    }
  }, [order])

  useEffect(() => {
    if (order && order.clientProfileData.document && documents.length === 0) {
      fetchDocuments(order.clientProfileData.document)
    }
  }, [])

  if (isLoading || !order) {
    return (
      <LayoutWrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '40px 32px' }}>
          <Inline size={48} aria-label="Carregando pedido" />
        </div>
      </LayoutWrapper>
    )
  }

  return (
    <LayoutWrapper>
      {!hideNavBar && <NavBar />}
      <PageContent>
        <Outlet />
      </PageContent>
    </LayoutWrapper>
  )
}
